/**
 * Product
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides the application store for all values related to the available Products.
 * These have been loaded from Woocommerce.
 */
export default {
  state: {
    products: [],
  },
  mutations: {
    ADD_PRODUCT(currentState, payload) {
      currentState.products.push(payload);
    },
  },
  actions: {
    addProduct(context, payload) {
      context.commit('ADD_PRODUCT', payload);
    },
  },
  getters: {
    products(state) {
      return state.products;
    },
    standardGlasses(state) {
      return state.products.filter((product) => product.type === 'standard-glass');
    },
    extensionGlasses(state) {
      return state.products.filter((product) => product.type === 'extension-glass');
    },
    connectors(state) {
      return state.products.filter((product) => product.type === 'connector' && !product.isInline);
    },
    stands(state) {
      return state.products.filter((product) => product.type === 'stand');
    },
    clampApprovedStands(state) {
      return state.products.filter((product) => product.type === 'stand' && product.isClampApproved);
    },
    clamps(state) {
      return state.products.filter((product) => product.type === 'clamp');
    },
    inLineConnector(state) {
      return state.products.filter((product) => product.type === 'connector' && product.isInline)[0];
    },
    endConnector(state) {
      return state.products.filter((product) => product.type === 'connector' && product.isEnd)[0];
    },
  },
};
